// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v5.5.1-jSoAt0XH0RmA5q5lMsh2/mode=imports,min/optimized/keen-slider.js'

class GWPPDPSlider extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.interval = 0
    this.autoplay = (run, instance) => {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        if (run && instance) {
          instance.next()
        }
      }, 5000)
    }

    this.slidesEl = this.querySelector('[data-gwp-pdp-slider-el="slides"]')
    this.slideEls = this.querySelectorAll('[data-gwp-pdp-slider-el="slide"]')
    this.dotEls = this.querySelectorAll('[data-gwp-pdp-slider-el="dot"]')

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 1000,
      loop: true,
      mode: 'snap',
      slidesPerView: 1,
      slides: '[data-gwp-pdp-slider-el="slide"]',
      created: instance => {
        this.dotEls.forEach(dotEl => {
          dotEl.addEventListener('click', this.handleDotClick.bind(this))
        })
        this.slidesEl.addEventListener('mouseover', () => {
          this.autoplay(false, instance)
        })
        this.slidesEl.addEventListener('mouseout', () => {
          this.autoplay(true, instance)
        })
        this.autoplay(true, instance)
      },
      slideChanged: instance => {
        this.dotEls.forEach(dot => {
          dot.setAttribute(
            'aria-current',
            parseInt(dot.dataset.slide) === instance.details().relativeSlide,
          )
        })
      },
      move: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide,
          )
        })
      },
    })
  }

  handleDotClick (event) {
    this.carousel.moveToSlide(event.target.dataset.slide)
  }
}

if (!customElements.get('gwp-pdp-slider')) {
  customElements.define('gwp-pdp-slider', GWPPDPSlider)
}
